/**
 * Shared helpers for invoice line item operations.
 * Used by both EditInvoiceLineItemsForm (side panel) and InvoiceLineItemsQuestion (inline editing).
 */

export function addLineItem(settings, setSettings) {
    const lineItems = settings?.lineItems || [];
    const newLineItems = [
        ...lineItems,
        { name: '', quantity: 1, unitPrice: 0 }
    ];
    setSettings({ ...settings, lineItems: newLineItems });
}

export function removeLineItem(settings, setSettings, index) {
    const lineItems = settings?.lineItems || [];
    const newLineItems = lineItems.filter((_, i) => i !== index);
    setSettings({ ...settings, lineItems: newLineItems });
}

export function updateLineItem(settings, setSettings, index, field, value) {
    const lineItems = settings?.lineItems || [];
    const newLineItems = [...lineItems];
    newLineItems[index] = {
        ...newLineItems[index],
        [field]: value
    };
    setSettings({ ...settings, lineItems: newLineItems });
}

export function setLineItemFields(settings, setSettings, index, fields) {
    const lineItems = settings?.lineItems || [];
    const newLineItems = [...lineItems];
    newLineItems[index] = {
        ...newLineItems[index],
        ...fields
    };
    setSettings({ ...settings, lineItems: newLineItems });
}

export function calculateLineItemTotal(item) {
    return (item.quantity || 0) * (item.unitPrice || 0);
}

export function calculateGrandTotal(lineItems) {
    return (lineItems || []).reduce((sum, item) => sum + calculateLineItemTotal(item), 0);
}

